export default {
    corner: `10px`
};
